import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getCardsListAsyncAction = createAsyncAction(
	"GET_CARDS_LIST_REQUEST",
	"GET_CARDS_LIST_SUCCESS",
	"GET_CARDS_LIST_FAILURE",
	"GET_CARDS_LIST_CANCEL"
);

export const postCardAsyncAction = createAsyncAction(
	"POST_CARDS_CREATE_REQUEST",
	"POST_CARDS_CREATE_SUCCESS",
	"POST_CARDS_CREATE_FAILURE",
	"POST_CARDS_CREATE_CANCEL"
);

export const postManyCardsAsyncAction = createAsyncAction(
	"POST_CARDS_CREATE_MANY_REQUEST",
	"POST_CARDS_CREATE_MANY_SUCCESS",
	"POST_CARDS_CREATE_MANY_FAILURE",
	"POST_CARDS_CREATE_MANY_CANCEL"
);

export const updateCardAsyncAction = createAsyncAction(
	"PUT_CARDS_UPDATE_REQUEST",
	"PUT_CARDS_UPDATE_SUCCESS",
	"PUT_CARDS_UPDATE_FAILURE",
	"PUT_CARDS_UPDATE_CANCEL"
);

export const getCardAsyncAction = createAsyncAction(
	"GET_CARDS_CARD_REQUEST",
	"GET_CARDS_CARD_SUCCESS",
	"GET_CARDS_CARD_FAILURE",
	"GET_CARDS_CARD_CANCEL"
);

export const resetAction = createAction("CARDS_RESET_ACTIONS");
